<section class="surface">
	@if (user()) {
		<lvr-heading [showEditButton]="canOpenUserSettings()" (editClicked)="openEdit()">
			{{ 'user.user_view.title' | transloco }}
		</lvr-heading>
		<lvr-admin-user-view
			[user]="user()!"
			[userGender]="userGender()"
			[canReadPositionShareDetails]="canReadPositionShareDetails()"
		/>
		@if (canReadPositionShares()) {
			<div lvrPadding [padHorizontal]="24" [padVertical]="24">
				<lvr-position-share-list [userId]="+user()!.id" [canEditPositionShares]="false"> </lvr-position-share-list>
			</div>
		}
	}
	@if (showDevTools) {
		<p style="margin-top: 32px">Deployment Info (nur während der Entwicklung sichtbar):</p>
		<p [innerHTML]="DEPLOYMENT_INFO"></p>
		<div class="token">
			<button matButton="filled" class="btn btn-primary" (click)="openScalar()">Copy Token and Open Scalar</button>

			<button matButton="filled" class="btn btn-primary" (click)="temporaryTokenCopy()">
				Copy Access Token (for DEV only)
			</button>

			<button matButton="filled" class="btn btn-primary" (click)="openTemplateUpdate()">
				Update Report Template (DEV)
			</button>
		</div>
	}
</section>
